export const costSheets = (state = [], action) => {
  if (action.type === 'FETCH_COST_SHEETS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_COST_SHEETS') {
    return [];
  }
  return state;
};

export const costSheet = (state = {}, action) => {
  if (action.type === 'FETCH_COST_SHEET') {
    return action.payload;
  }
  if (action.type === 'CLEAR_COST_SHEET') {
    return {};
  }
  return state;
};
